const FeatureBaseComponent = defineComponent({
  setup() {
    onBeforeMount(() => {
      const script = document.createElement("script");
      script.src = "https://do.featurebase.app/js/sdk.js";
      script.id = "featurebase-sdk";
      document.head.appendChild(script);
    });

    onMounted(() => {
      const win: any = window;

      // Only create placeholder if Featurebase doesn't exist at all
      if (typeof win.Featurebase === "undefined") {
        win.Featurebase = function () {
          (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
        };
        // Mark this as a placeholder so we can detect when the real SDK loads
        win.Featurebase._isPlaceholder = true;
      }
    });

    return () => {
      return (
        <div></div>
      )
    }
  }
})

export default FeatureBaseComponent
